import { EVENT_NAME_OBJECT_MESSAGE } from '@constants'

export type MessageBody = {
  eventName: EVENT_NAME_OBJECT_MESSAGE
  objectCode: string
  objectId: string
  changedFields: Record<string, unknown> | null
}

type IncomingWebSocketMessage = {
  changes: {
    record: Array<{ field: string; newValue: unknown; oldValue: unknown }>
  } | null
  content: string
  date: string
  eventName: string
  objectCode: string
  objectId: string
  userName: string
}

export const parseMessageBody = (rawBody: string): MessageBody => {
  const msg: IncomingWebSocketMessage = JSON.parse(rawBody)

  return {
    eventName: msg.eventName as EVENT_NAME_OBJECT_MESSAGE,
    objectCode: msg.objectCode,
    objectId: msg.objectId,
    changedFields: msg.changes?.record
      ? Object.fromEntries(msg.changes.record.map(r => [r.field, r.newValue]))
      : null,
  }
}

export type MessageGanttBody = {
  ganttId: number
  eventName: string
  objectCode: string
  objectIds: Array<string>
}
